import { Radio, Badge } from "antd";

export interface Tab {
  index: number;
  title: string;
  value?: any;
  className?: string;
  count?: number;
}

interface TabBoxProps {
  children: Array<Tab>;
  onChange: (name: string, index: number, value?: any) => void;
  name?: string;
  activeTab: number;
}

const TabBox = ({ children, onChange, activeTab, name = "" }: TabBoxProps) => {
  return (
    <Radio.Group
      size="small"
      value={activeTab}
      defaultValue={activeTab}
      className="w-full flex flex-row justify-start items-start"
    >
      {children.map((tab) => (
        <>
          {tab?.count !== undefined && tab?.count !== null ? (
            <>
              <div
                className={`-top-3 -left-3 rounded-full text-white text-[10px] flex items-center justify-center pt-[3px] absolute z-10 bg-red-500 w-6 h-6`}
              >
                {tab.count > 99 ? "99+" : tab.count}
              </div>
              <Radio.Button
                key={tab.index}
                value={tab.index}
                onChange={() => onChange(name, tab.index, tab.value)}
                checked={tab.index === activeTab}
                className={`flex grow justify-center items-center whitespace-nowrap before:!hidden !text-xs
              ${
                tab.className
                  ? tab.className
                  : tab.index === activeTab
                    ? "!bg-sky-600 hover:!bg-sky-700 !text-white"
                    : "!border-gray-300 !text-gray-300 hover:!text-gray-400"
              }`}
              >
                {tab.title}
              </Radio.Button>
            </>
          ) : (
            <Radio.Button
              key={tab.index}
              value={tab.index}
              onChange={() => onChange(name, tab.index, tab.value)}
              checked={tab.index === activeTab}
              className={`flex grow justify-center items-center whitespace-nowrap before:!hidden !text-xs
              ${
                tab.className
                  ? tab.className
                  : tab.index === activeTab
                    ? "!bg-sky-600 hover:!bg-sky-700 !text-white"
                    : "!border-gray-300 !text-gray-300 hover:!text-gray-400"
              }`}
            >
              {tab.title}
            </Radio.Button>
          )}
        </>
      ))}
    </Radio.Group>
  );
};

export default TabBox;
